/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon16Light = forwardRef('AttachLinkIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M.5 7.5A4.5 4.5 0 0 1 5 3h1.5a.5.5 0 0 1 0 1H5a3.5 3.5 0 1 0 0 7h1.5a.5.5 0 0 1 0 1H5A4.5 4.5 0 0 1 .5 7.5Z" }),
        React.createElement("path", { d: "M15.5 7.5A4.5 4.5 0 0 0 11 3H9.5a.5.5 0 0 0 0 1H11a3.5 3.5 0 1 1 0 7H9.5a.5.5 0 0 0 0 1H11a4.5 4.5 0 0 0 4.5-4.5Z" }),
        React.createElement("path", { d: "M5 7a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5Z" })));
});
